/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {NgModule} from '@angular/core';
import {AbmsBoardModule} from './board/abms/abms-board.module';
import {AbpsBoardModule} from './board/abps/abps-board.module';
import {BoardAffiliationInformationModule} from './board/information/board-affiliation-information.module';
import {ProfessionalLicenseModule} from './professional/professional-license.module';
import {InactiveLicensesInformationModule} from './inactive/inactive-licenses-information.module';
import {DeaRegistrationModule} from './dea/dea-registration.module';
import {LifeCertificationModule} from './lifecertification/life-certification.module';
import {LicensingExaminationModule} from './licensingexamination/licensing-examination.module';
import {ContinuingMedicalEducationModule} from './cme/continuing-medical-education.module';
import {AoaBoardModule} from './board/aoa/aoa-board.module';

@NgModule({
    imports: [
        AbmsBoardModule,
        AbpsBoardModule,
        AoaBoardModule,
        BoardAffiliationInformationModule,
        ProfessionalLicenseModule,
        InactiveLicensesInformationModule,
        DeaRegistrationModule,
        LifeCertificationModule,
        LicensingExaminationModule,
        ContinuingMedicalEducationModule
    ]
})
export class LicensesCertificationsModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/licenses-certifications.module.ts